import * as Sentry from '@sentry/react';
import { isProdInstance } from 'consts/config';

const DSN = import.meta.env.REACT_APP_SENTRY_DSN;

const sentryEnv = isProdInstance ? 'production' : 'development';

if (sentryEnv === 'production') {
  Sentry.init({
    dsn: DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    environment: sentryEnv,
    enabled: !!DSN,
  });
}
